module.exports = __webpack_public_path__ + "static/media/note-5.144fb68f.jpg";